import { render } from "./ChatCommentsComponent.vue?vue&type=template&id=dfb93c4a&scoped=true&ts=true"
import script from "./ChatCommentsComponent.vue?vue&type=script&lang=ts"
export * from "./ChatCommentsComponent.vue?vue&type=script&lang=ts"

import "./ChatCommentsComponent.vue?vue&type=style&index=0&id=dfb93c4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb93c4a"]])

export default __exports__